import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

// Registrar Pusher globalmente
window.Pusher = Pusher

// Função para obter o User ID (funcionarioId do localStorage)
const getUserId = () => localStorage.getItem('funcionarioId') || localStorage.getItem('userId')

// Configurar Echo para Vue CLI (usando process.env ao invés de import.meta.env)
const echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.VUE_APP_PUSHER_APP_KEY,
  cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
  wsHost: process.env.VUE_APP_PUSHER_HOST,
  wsPort: parseInt(process.env.VUE_APP_PUSHER_PORT, 10),
  wssPort: parseInt(process.env.VUE_APP_PUSHER_PORT, 10),
  forceTLS: process.env.VUE_APP_PUSHER_USE_TLS === 'true',
  encrypted: true,
  disableStats: true,
  enabledTransports: ['ws', 'wss'],

  // Autenticação para canais privados
  auth: {
    headers: {
      'X-Service-Key': process.env.VUE_APP_SERVICE_KEY,
      'X-User-Id': getUserId(),
      Accept: 'application/json',
    },
  },
  // Endpoint de autenticação usa o proxy /internal configurado no vue.config.js
  authEndpoint: '/internal/broadcasting/auth',
})

export default echo
